import logo from '../../assets/images/crb-logo.png';

export default function CRBCLogo() {
    return(
        <img src={String(logo)} alt="logo" className="logo"/>
    );
}